// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Enums
import { ScatterPlotChartOptionValue } from 'ChartApp/ts/enums/scatter-plot-common.enum';
// NgRx actions / selectors
import { setChartOption } from './chart-options.actions';
import { setScatterPlot } from '../scatter-plot.actions';
export const displayAllCurrencyCodes = createReducer(false, on(setChartOption, (state, action) => {
    if (action.chartOption.value === ScatterPlotChartOptionValue.displayAllCurrencyCodes) {
        return action.chartOption.selected;
    }
    return state;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.displayAllCurrencyCodes;
}));
